import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StateManagerLookupComponent } from './state-manager-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [StateManagerLookupComponent],
  exports: [StateManagerLookupComponent]
})
export class StateManagerLookupModule { }
